import { render, staticRenderFns } from "./OBtnToolTipTableComp.vue?vue&type=template&id=0f56d72d&"
import script from "./OBtnToolTipTableComp.vue?vue&type=script&lang=js&"
export * from "./OBtnToolTipTableComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports